/*
 *  Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const UnstyledButton = styled.button`
  width: 100%;
  background: inherit;
  border: none;
  text-align: left;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  cursor: pointer;
  max-width: 15rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const PredefinedFiltersWrapper = styled.div({
  borderRadius: theme.radiusDefault,
  backgroundColor: theme.color.background.ui01,
  minWidth: "12rem",
  padding: theme.spacing.spacing04,
  boxShadow: theme.shadow.shadow04,
});
